module.exports = __webpack_public_path__ + "img/N326-1.03de944c.png";